import { startCase } from "lodash-es";

export const normalizeStatusValue = ({ status }: { status: string }) => status.trim().toLowerCase();

export const formatStatusLabel = ({ status }: { status: string }) => {
  const normalizedStatus = status.trim();

  if (!normalizedStatus) {
    return "Unknown";
  }

  return startCase(normalizedStatus);
};
